import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

export function GraphBulkIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.1528 5.55559C10.2037 5.65925 10.2373 5.77027 10.2524 5.8844L10.5308 10.0243L10.669 12.1051C10.6705 12.3191 10.704 12.5317 10.7687 12.7361C10.9356 13.1326 11.3372 13.3846 11.7741 13.3671L18.4313 12.9316C18.7196 12.9269 18.998 13.0347 19.2052 13.2313C19.3779 13.3952 19.4894 13.6096 19.5246 13.8402L19.5364 13.9802C19.2609 17.795 16.4592 20.9767 12.6524 21.7981C8.84555 22.6194 4.94186 20.8844 3.06071 17.535C2.51839 16.5619 2.17965 15.4923 2.06438 14.389C2.01623 14.0624 1.99503 13.7326 2.00098 13.4026C1.99503 9.31279 4.90747 5.77702 8.98433 4.92463C9.47501 4.84822 9.95603 5.10798 10.1528 5.55559Z"
        fill="currentColor"
      />
      <path
        opacity="0.4"
        d="M12.8686 2.00082C17.4285 2.11683 21.2609 5.39579 21.9986 9.81229L21.9916 9.84488L21.9714 9.89227L21.9742 10.0224C21.9638 10.1947 21.8972 10.3605 21.7826 10.4945C21.6631 10.634 21.4999 10.729 21.3202 10.7659L21.2106 10.7809L13.5298 11.2786C13.2743 11.3038 13.0199 11.2214 12.8299 11.052C12.6716 10.9107 12.5704 10.7201 12.5418 10.5147L12.0263 2.84506C12.0173 2.81913 12.0173 2.79102 12.0263 2.76508C12.0333 2.55367 12.1264 2.35384 12.2846 2.21023C12.4429 2.06662 12.6532 1.9912 12.8686 2.00082Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
